import React,{Component} from 'react';

import {Card,CardBody} from 'reactstrap';

import MoneyDisplay from '../../../shared/components/MoneyDisplay';

import {
  formatDateRange,
  timeForEngagements,
  humanReadableTime,
  humanReadableList,
  costPerCompletion,
  audienceSizeForCampaignInStates,
  toTitleCase,
  geoFilterSort,
  typeOfContraints
} from '../../../shared/utils';



class CampaignOverview extends Component {

  getAudience(){
    const {activeCampaign,possibleGeoFilters} = this.props;

    const matchingFilterNames = (activeCampaign.filters || [])
      .map((f) => possibleGeoFilters.find((g) => g.code === f.code))
      .filter((f) => !!f)
      .sort((a,b) => geoFilterSort(a,b))
      .map((f) => toTitleCase(f.name.toLowerCase()));

    if(activeCampaign.geoFilterPredicate && possibleGeoFilters.length === 0){
      return 'Loading...'
    } else if(activeCampaign.geoFilterPredicate === 'include'){
      return humanReadableList(matchingFilterNames);
    } else if(activeCampaign.geoFilterPredicate === 'exclude'){
      return `Nationwide excluding ${matchingFilterNames}`;
    } else { 
      return 'Nationwide';
    }
  }

  getResponseTargeting(){
    const {
      activeCampaign
    } = this.props; 

    const constraintType = typeOfContraints(activeCampaign.constraints);

    if(!activeCampaign || (activeCampaign && !activeCampaign.constraints)){
      return 'Loading...';
    } else if(constraintType === 'all' || constraintType === ''){
      return 'None';
    } else if(constraintType === 'completed'){
      return 'Completed Experience';
    } else {
      return 'Selected Response(s)';
    }
  }

  getReach(){
    const {
      activeCampaign,
      activeEngagements,
      possibleStates
    } = this.props;

    if(!activeCampaign.reach || activeCampaign.reach === 0){
      return 'Loading...'
    } else if(!activeEngagements || activeEngagements.length === 0){
      return '0 consumers';
    } else {
      const reachDenominator = costPerCompletion(activeCampaign,activeEngagements),
        reachNumerator = activeCampaign.lifetimeBudget,
        reachSize = Math.round(reachDenominator > 0 ? reachNumerator/reachDenominator : 0),
        audienceSize = activeCampaign.reach || 0;

        return `${Math.min(audienceSize,reachSize)} consumers`;
    }
  }

  render(){
    const { activeCampaign, activeEngagements, activePromoCode } = this.props;

    const reachDenominator = costPerCompletion(activeCampaign,activeEngagements),
      reachNumerator = activeCampaign.lifetimeBudget,
      reach = Math.round(reachDenominator > 0 ? reachNumerator/reachDenominator : 0),
      youPay = (activeCampaign.lifetimeBudget || 0) - (activePromoCode.amount || 0);

    return (
      <Card>
        <CardBody>
          <h3>Budget & Reach</h3>
          <div>
            <strong><MoneyDisplay>{activeCampaign.lifetimeBudget || 0}</MoneyDisplay> budget</strong>
            {activePromoCode.amount && (
              <div>
                <small className="text-muted">You pay <MoneyDisplay>{youPay > 0 ? youPay : 0}</MoneyDisplay></small>
              </div>
            )}
          </div>
          <div>
            <strong>{humanReadableTime(timeForEngagements(activeEngagements))}</strong>
            <br />
            <small className="text-muted">Estimated time spent per consumer</small>
          </div>
          <div>
            <strong><MoneyDisplay>{activeCampaign.costPerCompletion}</MoneyDisplay></strong>
            <br />
            <small className="text-muted">Cost per completion</small>
          </div>
          <div>
            <strong>{this.getReach().toLocaleString()}</strong>
            <br />
            <small className="text-muted">Reach</small>
          </div>
          <div>
            <strong>{this.getAudience()}</strong>
            <br />
            <small className="text-muted">Audience</small>
          </div>
          <div>
            <strong>{this.getResponseTargeting()}</strong>
            <br />
            <small className="text-muted">Response Targeting</small>
          </div>
          {activeCampaign.launchDate && activeCampaign.endDate && (
            <strong>
              {formatDateRange(activeCampaign.launchDate,activeCampaign.endDate,'to')}
            </strong>
          )}
          {activeCampaign.launchDate && (!activeCampaign.endDate) && (
            <strong>
              Starts {formatDateRange(activeCampaign.launchDate)}
            </strong>
          )}
        </CardBody>
      </Card>
    )
  }
}

export default CampaignOverview



// WEBPACK FOOTER //
// ./src/routes/GuidedCampaignReview/components/CampaignOverview.js